import { render, staticRenderFns } from "./Gobierno.vue?vue&type=template&id=10d65257&"
import script from "./Gobierno.vue?vue&type=script&lang=js&"
export * from "./Gobierno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports